var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Azerbaijan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#03a9f4",
    d: "M24,4C15.421,4,8.125,9.412,5.284,17h37.431C39.875,9.412,32.579,4,24,4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff3d00",
    d: "M44,24c0-2.467-0.468-4.818-1.284-7H5.284C4.468,19.182,4,21.533,4,24s0.468,4.818,1.284,7h37.431 C43.532,28.818,44,26.467,44,24z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#43a047",
    d: "M42.716,31H5.284C8.125,38.588,15.421,44,24,44S39.875,38.588,42.716,31z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.031,24c0,2.211-1.789,4-4,4c-2.207,0-4-1.789-4-4s1.793-4,4-4C25.242,20,27.031,21.789,27.031,24 z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff3d00",
    d: "M27.254,24c0,1.84-1.492,3.332-3.332,3.332S20.59,25.84,20.59,24s1.492-3.332,3.332-3.332 S27.254,22.16,27.254,24z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.777,21.777l0.426,1.195l1.145-0.543l-0.543,1.145L30,24l-1.195,0.426l0.543,1.145l-1.145-0.543 l-0.426,1.195l-0.426-1.195l-1.145,0.543l0.547-1.145L25.555,24l1.199-0.426l-0.547-1.145l1.145,0.543L27.777,21.777z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Azerbaijan);
export default __webpack_public_path__ + "static/media/icons8-azerbaijan.d587dea84d797c34273d9e6f66a8ba32.svg";
export { ForwardRef as ReactComponent };